module.exports = __webpack_public_path__ + "static/media/sa.cddae107.ogg";